import MandatePage from '@/pages/Manda/MandatePage.vue'
import FormPage from '@/pages/Manda/GroupFormPage.vue'
// import FormPageSDD from '@/pages/Manda/GroupFormPageSDD.vue'
import FormPageUnitSDD from '@/pages/Manda/FormPageUnitSDD.vue'
import FormPageBulkSDD from '@/pages/Manda/FormPageBulkSDD.vue'
import FormPageSCT from '@/pages/Manda/GroupFormPageSCT.vue'
import MandateDetail from '@/pages/Manda/MandateDetails.vue'
import MandateDetailBulk from '@/pages/Manda/MandateDetailsBulk.vue'
import MandateTransactions from '@/pages/Manda/MandateTransactions.vue'
import MandateTransactionsDetailsUnit from '@/pages/Manda/MandateTransactionsDetailsUnit.vue'
import MandateTransactionsDetailsBulk from '@/pages/Manda/MandateTransactionsDetailsBulk.vue'
import FormPageUnitDbtr from '@/pages/Manda/FormPageUnitDbtr.vue'
import ModeChoice from '@/pages/Manda/ModeChoice.vue'
import BankSelection from '@/pages/Manda/BankSelection.vue'
import MandateDashboard from '@/pages/Manda/MandateDashboard.vue'
import ReportBuilder from '@/pages/Manda/ReportBuilder.vue'
import FraudCaseDetails from '@/pages/Manda/FraudCaseDetails.vue'
import BackgroundJobPage from '@/pages/Manda/BackgroundJobPage.vue'

export default [
  {
    path: '/mandate-dashboard',
    component: MandateDashboard
  },
  {
    path: '/report-builder',
    component: ReportBuilder
  },
  {
    path: '/fraud-case/:caseId',
    component: FraudCaseDetails,
    props: true
  },
  {
    path: '/modechoice',
    component: ModeChoice
  },
  {
    path: '/bankselection',
    component: BankSelection
  },
  {
  path: '/mandatpage/:type',
  component: MandatePage,
  props: true
  },
  {
    path: '/formpagesdd/cdtr/unit/',
    component: FormPageUnitSDD,
    props: true
  },
  {
    path: '/formpagesdd/cdtr/bulk/',
    component: FormPageBulkSDD,
    props: true
  },
  {
  path: '/mandatetransactions/:type',
  component: MandateTransactions,
  props: true
  },
  {
  path: '/formpage/:type',
  component: FormPage,
  props: true
  },
  // {
  // path: '/formpagesdd/:type',
  // component: FormPageSDD,
  // props: true
  // },
  {
  path: '/mandatedetail/:mandateId',
  component: MandateDetail,
  props: true
  },
  {
  path: '/mandatedetailbulk/:IdMandateBulk',
  component: MandateDetailBulk,
  props: true
  },
  {
  path: '/formpagesct/:type',
  component: FormPageSCT,
  props: true
  },
  {
    path: '/mandatetransactionsunit/details/:idCollection',
    component: MandateTransactionsDetailsUnit
  },
  {
    path: '/mandatetransactionsbulk/details/:idCollectionBulk',
    component: MandateTransactionsDetailsBulk
  },
  // {
  //   // lien public : /Mandate_dbtr?token=xxx ou /Mandate_dbtr/:token
  //   path: '/Mandate_dbtr/:token?',
  //   component: FormPageUnitDbtr,
  //   props: route => ({
  //     type: 'dbtr',
  //     token: route.params.token || route.query.token || ''
  //   })
  // }
  {
  path: '/Mandat_dbtr/:token?',
    component: FormPageUnitDbtr,
    props: true
  },
  {
    path: '/BackgroundJob/',
    component: BackgroundJobPage,
    props: true
  }
]
